var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Login", {
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [
            _c("span", { attrs: { id: "loginTitle" } }, [
              _vm._v(_vm._s(_vm.$t("ResetPassword")))
            ])
          ]
        },
        proxy: true
      },
      {
        key: "form",
        fn: function() {
          return [
            _c(
              "form",
              {
                staticClass: "loginForm",
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.submit.apply(null, arguments)
                  }
                }
              },
              [
                _c("div", { staticClass: "main-login-form-container" }, [
                  _c("div", { staticClass: "password-div" }, [
                    _c("span", { staticClass: "login-input-label" }, [
                      _vm._v(_vm._s(_vm.$t("NewPassword")))
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password"
                        }
                      ],
                      ref: "password",
                      staticClass: "loginInput userInput effect-7",
                      class: {
                        fieldErrorInput: _vm.badPassword || _vm.badLength
                      },
                      attrs: {
                        type: "password",
                        name: "password",
                        spellcheck: "false"
                      },
                      domProps: { value: _vm.password },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.PasswordRecoverySubmit.apply(
                            null,
                            arguments
                          )
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.password = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "password-div" }, [
                    _c("span", { staticClass: "login-input-label" }, [
                      _vm._v(_vm._s(_vm.$t("ConfirmNewPassword")))
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.confirmPassword,
                          expression: "confirmPassword"
                        }
                      ],
                      ref: "confirmPassword",
                      staticClass: "loginInput userInput effect-7",
                      class: {
                        fieldErrorInput: _vm.badPassword || _vm.badLength
                      },
                      attrs: {
                        type: "password",
                        name: "confirmPassword",
                        spellcheck: "false"
                      },
                      domProps: { value: _vm.confirmPassword },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.PasswordRecoverySubmit.apply(
                            null,
                            arguments
                          )
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.confirmPassword = $event.target.value
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "field-error-div" }, [
                  _vm.badPassword
                    ? _c("span", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("PasswordsDontMatch")) +
                            "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.badLength
                    ? _c("span", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("PasswordLength")) +
                            "\n        "
                        )
                      ])
                    : _vm._e()
                ])
              ]
            )
          ]
        },
        proxy: true
      },
      {
        key: "button",
        fn: function() {
          return [
            _c(
              "v-btn",
              {
                staticClass: "signInInput",
                attrs: {
                  type: "submit",
                  color: "accent--text",
                  outlined: "",
                  disabled: !_vm.passwordIsValid
                },
                on: { click: _vm.PasswordRecoverySubmit }
              },
              [_vm._v("\n      " + _vm._s(_vm.$t("Send")) + "\n    ")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a7ddc1da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7ddc1da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/LoginPasswordRecovery.vue
// module id = null
// module chunks = 